import type { ColorChoice, LobbyRoom, TimeControl } from '@billycheckers/shared';

export interface LobbyHandlers {
  onCreate(timeControl: TimeControl, color: ColorChoice): void;
  onJoin(roomId: string): void;
  onName(name: string): void;
}

const TC_LABEL: Record<TimeControl, string> = {
  none: 'без часов',
  '5min': '5 минут',
  '10min': '10 минут',
};

/** Лобби: имя, создание игры, живой список комнат. */
export class LobbyScreen {
  readonly el: HTMLElement;
  private roomsEl: HTMLElement;
  private nameInput: HTMLInputElement;

  constructor(h: LobbyHandlers) {
    this.el = document.createElement('div');
    this.el.className = 'lobby';

    const create = document.createElement('form');
    create.className = 'create';

    const nameLabel = document.createElement('label');
    nameLabel.className = 'f wide';
    nameLabel.append('ваше имя');
    this.nameInput = document.createElement('input');
    this.nameInput.type = 'text';
    this.nameInput.maxLength = 24;
    this.nameInput.placeholder = 'Гость';
    this.nameInput.setAttribute('autocomplete', 'nickname');
    this.nameInput.addEventListener('change', () => h.onName(this.nameInput.value.trim()));
    nameLabel.appendChild(this.nameInput);

    const tcLabel = document.createElement('label');
    tcLabel.className = 'f';
    tcLabel.append('время');
    const tcSel = document.createElement('select');
    for (const [v, title] of Object.entries(TC_LABEL)) {
      const o = document.createElement('option');
      o.value = v;
      o.textContent = title;
      tcSel.appendChild(o);
    }
    tcLabel.appendChild(tcSel);

    const colorLabel = document.createElement('label');
    colorLabel.className = 'f';
    colorLabel.append('ваш цвет');
    const colorSel = document.createElement('select');
    for (const [v, title] of [['random', 'случайно'], ['white', 'белые'], ['black', 'чёрные']]) {
      const o = document.createElement('option');
      o.value = v!;
      o.textContent = title!;
      colorSel.appendChild(o);
    }
    colorLabel.appendChild(colorSel);

    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'btn primary wide';
    submit.textContent = 'Создать игру';

    create.append(nameLabel, tcLabel, colorLabel, submit);
    create.addEventListener('submit', (e) => {
      e.preventDefault();
      h.onName(this.nameInput.value.trim());
      h.onCreate(tcSel.value as TimeControl, colorSel.value as ColorChoice);
    });

    const roomsHead = document.createElement('p');
    roomsHead.className = 'eyebrow';
    roomsHead.textContent = 'Комнаты';

    this.roomsEl = document.createElement('div');
    this.roomsEl.className = 'rooms';

    this.el.append(create, roomsHead, this.roomsEl);
    this.update([], h);
    this.handlers = h;
  }

  private handlers: LobbyHandlers;

  setName(name: string): void {
    if (document.activeElement !== this.nameInput) this.nameInput.value = name;
  }

  update(rooms: LobbyRoom[], h: LobbyHandlers = this.handlers): void {
    this.roomsEl.replaceChildren();
    if (rooms.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'empty';
      empty.textContent = 'Пока пусто. Создайте первую игру и пришлите другу ссылку.';
      this.roomsEl.appendChild(empty);
      return;
    }
    for (const r of rooms) {
      const row = document.createElement('div');
      row.className = 'room-row';
      const info = document.createElement('div');
      const names = document.createElement('div');
      names.className = 'names';
      names.textContent =
        r.white && r.black ? `${r.white} — ${r.black}`
        : `${r.white ?? r.black ?? '…'} ждёт соперника`;
      const meta = document.createElement('div');
      meta.className = 'meta';
      const status =
        r.status === 'waiting' ? 'ждёт' : r.status === 'playing' ? 'идёт партия' : 'завершена';
      const parts = [status, TC_LABEL[r.timeControl]];
      if (r.spectators > 0) parts.push(`зрителей: ${r.spectators}`);
      meta.textContent = parts.join(' · ');
      info.append(names, meta);
      const btn = document.createElement('button');
      btn.className = 'btn' + (r.status === 'waiting' ? ' primary' : '');
      btn.textContent = r.status === 'waiting' ? 'Играть' : 'Смотреть';
      btn.addEventListener('click', () => h.onJoin(r.id));
      row.append(info, btn);
      this.roomsEl.appendChild(row);
    }
  }
}
